import axios from 'axios';
import { RouteLocationRaw, Router } from 'vue-router';

import { tokenService, useAuthStore } from '@tallo/auth';

class AxiosService {
  private clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  setBaseUrl(url: string | undefined) {
    if (!url) {
      throw Error('Base URL is not defined');
    }

    axios.defaults.baseURL = url;
  }

  getBaseUrl(): string {
    return axios.defaults.baseURL ? axios.defaults.baseURL : '';
  }

  setAuthToken(token: string | null) {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  setAuthInterceptor(router: Router, fallbackRoute: RouteLocationRaw): void {
    axios.interceptors.request.use(
      (config) => {
        const token = tokenService.getToken();

        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          const authStore = useAuthStore();

          authStore.logout();
          router.push(fallbackRoute);
        }

        return Promise.reject(error);
      },
    );
  }

  setTimeZoneHeader(): void {
    axios.interceptors.request.use(
      (config) => {
        config.headers['Client-Time-Zone'] = this.clientTimeZone;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }
}

export default new AxiosService();
